import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { NginV2ApiService } from './nginV2Api.service'

export class CommerceOrder {
  public sale_number?: string | number
  public id?: number

  public constructor(data?: Partial<CommerceOrder>) {
    Object.assign(this, data || {})
  }
}

export class CommerceOrderActivity {
  public constructor(data?: Partial<CommerceOrderActivity>) {
    Object.assign(this, data || {})
  }
}

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  constructor(private api: NginV2ApiService) {
    // noop
  }

  public index(user_id: string | number, sale_numbers: string): Observable<any[]> {
    return this.api.findAllAs(
      'commerce/orders',
      { params: { user_id, sale_numbers, per_page: 100 } },
      CommerceOrder
    )
  }

  public find(id: string): Observable<any> {
    return this.api.findAs(
      `commerce/orders/${id}`,
      CommerceOrder
    )
  }

  public significantActivity(id: number): Observable<any[]> {
    return this.api.findAllAs(
      `commerce/orders/${id}/activity`,
      { params: { view_mode: 'user', significance: 'high' } },
      CommerceOrderActivity
    )
  }
}
